import axios from "axios";

const baseURL = "https://api.huberfeichter.it/api/";

// Normaler API-Client
const axiosInstance = axios.create({
    baseURL,
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true,
});

// Separater Client für den Refresh
const refreshClient = axios.create({
    baseURL,
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true,
});

// Verhindert mehrere gleichzeitige Refresh-Anfragen
let refreshPromise = null;


// ========================================
// ACCESS TOKEN AUTOMATISCH ANHÄNGEN
// ========================================

axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);


// ========================================
// FEHLER / TOKEN REFRESH
// ========================================

axiosInstance.interceptors.response.use(
    (response) => response,

    async (error) => {
        const originalRequest = error.config;

        // --------------------------------
        // 403 - Keine Berechtigung
        // --------------------------------

        if (error.response?.status === 403) {
            return Promise.resolve({
                data: {},
                status: 403,
            });
        }

        // --------------------------------
        // Alles außer 401 normal weitergeben
        // --------------------------------

        if (error.response?.status !== 401) {
            return Promise.reject(error);
        }

        // --------------------------------
        // Login selbst nicht refreshen
        // --------------------------------

        if (originalRequest.url?.includes("/auth/login")) {
            return Promise.reject(error);
        }

        // --------------------------------
        // Refresh selbst nicht refreshen
        // --------------------------------

        if (originalRequest.url?.includes("/auth/refresh")) {
            localStorage.removeItem("token");
            window.location.href = "/login";

            return Promise.reject(error);
        }

        // --------------------------------
        // Request wurde bereits wiederholt
        // --------------------------------

        if (originalRequest._retry) {
            localStorage.removeItem("token");
            window.location.href = "/login";

            return Promise.reject(error);
        }

        originalRequest._retry = true;

        try {

            // --------------------------------
            // Nur einen Refresh gleichzeitig
            // --------------------------------

            if (!refreshPromise) {
                refreshPromise = refreshClient
                    .post("/auth/refresh")
                    .finally(() => {
                        refreshPromise = null;
                    });
            }

            const response = await refreshPromise;

            const newToken = response.data.token;

            // --------------------------------
            // Neuen Access Token speichern
            // --------------------------------

            localStorage.setItem("token", newToken);

            // --------------------------------
            // Ursprünglichen Request
            // mit neuem Token wiederholen
            // --------------------------------

            originalRequest.headers.Authorization =
                `Bearer ${newToken}`;

            return axiosInstance(originalRequest);

        } catch (refreshError) {

            // --------------------------------
            // Refresh Token ungültig/abgelaufen
            // --------------------------------

            localStorage.removeItem("token");

            window.location.href = "/login";

            return Promise.reject(refreshError);
        }
    }
);

export default axiosInstance;